module.exports = __webpack_public_path__ + "static/media/Icon_Tutoren_kontaktieren.f9fd048f.svg";